<mat-card>
  <mat-card-header>
    <mat-card-title>Asistencias</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <form [formGroup]="asistenciaForm">
        <div fxLayout="row stretch" fxLayout.xs="column">
          <div fxFlex=34 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
              <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
              <mat-select formControlName="Comunidad">
                <mat-option *ngFor="let s of comunidadList" [value]="s">{{s.Nombre}}</mat-option>
              </mat-select>
              <mat-error
                *ngIf="!asistenciaForm.controls['Comunidad'].valid && asistenciaForm.controls['Comunidad'].touched">
                {{ getErrorComunidad() }}
              </mat-error>
            </mat-form-field>
          </div>
          <!-- FECHA DESDE -->
          <div fxFlex=33 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Fecha Desde</mat-label>
              <input matInput (dateChange)="onSearch()" [matDatepicker]="fechaDesdePicker" formControlName="FechaDesde"
                (click)="fechaDesdePicker.open()">
              <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaDesdePicker">
              </mat-datepicker-toggle>
              <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaDesde')">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #fechaDesdePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <!-- FECHA HASTA -->
          <div fxFlex=33 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Fecha Hasta</mat-label>
              <input matInput (dateChange)="onSearch()" [matDatepicker]="fechaHastaPicker" formControlName="FechaHasta"
                (click)="fechaHastaPicker.open()">
              <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaHastaPicker">
              </mat-datepicker-toggle>
              <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaHasta')">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #fechaHastaPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </form>

      <mat-expansion-panel *ngIf="isFormValid" [allowExcelExport]="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda Adicionales
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">

          <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nombre</mat-label>
                <input matInput type="text" formControlName="EmpleadoNombre">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Apellido</mat-label>
                <input matInput type="text" formControlName="EmpleadoApellido">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
            <!-- FECHA HASTA -->
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Cuit</mat-label>
                <input (keyup)="validateCuit($event.target.value)" matInput type="text" formControlName="Cuit">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isGremiosSearching">Gremio</mat-label>
                <mat-label *ngIf="isGremiosSearching">Cargando...</mat-label>
                <mat-select formControlName="GremioId">
                  <mat-option>Todas</mat-option>
                  <mat-option *ngFor="let s of gremioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isSubContratistaSearching">SubContratista</mat-label>
                <mat-label *ngIf="isSubContratistaSearching">Cargando...</mat-label>
                <input  type="text"
                        placeholder="Apellido o Nombre - Cuit"
                        aria-label="SubContratista"
                        matInput
                        formControlName="SubContratista"
                        [matAutocomplete]="subContratista">
                        <i [ngStyle]="{'display': isSubContratistaSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                <mat-autocomplete [displayWith]="displayFn"
                                  autoActiveFirstOption
                                  #subContratista="matAutocomplete">
                  <mat-option
                    *ngFor="let s of filteredSubContratistaList" [value]="s">
                    {{s.Apellido | uppercase}} {{s.Nombre | uppercase}} - {{s.Cuit}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </form>

      </mat-expansion-panel>

      <div *ngIf="isFormValid" fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
        <button mat-raised-button (click)="onSearch()" [disabled]="isSearching || isExporting" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
        <button mat-raised-button (click)="onExport()" [disabled]="isSearching || isExporting" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
      </div>

      <mat-expansion-panel expanded style="margin-top: 10px;" *ngIf="isFormValid && !tableError && !isSearching">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">list_alt</mat-icon> Asistencias
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="tablaAsistencia" fxLayout="row stretch" fxLayout.xs="column">
          <div fxFlex=50 fxFlex.xs=100>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isEmpleadoSerching">Empleado</mat-label>
              <mat-label *ngIf="isEmpleadoSerching">Cargando...</mat-label>
              <input  type="text"
                      placeholder="Apellido o Nombre - CUIT/CUIL"
                      aria-label="Empleado"
                      matInput
                      [formControl]="empleadoControl"
                      [matAutocomplete]="empleados">
                      <i [ngStyle]="{'display': isEmpleadoSerching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
              <mat-autocomplete [displayWith]="displayFn"
                                (optionSelected)="agregarEmpleadoObra($event.option.value)"
                                autoActiveFirstOption
                                #empleados="matAutocomplete">
                <mat-option
                  *ngFor="let s of filteredEmpleadoList" [value]="s">
                  {{s.Apellido | uppercase}} {{s.Nombre | uppercase}} - {{s.Cuit}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <div [style.margin-top.px]="20">
                <button (click)="agregarNuevoEmpleado()" title="Asignar empleado a obra"><i class="fa fa-plus"></i></button>
              </div>
            </div>
          </div>
          <table style="width:100%; display: table;text-align: center;" [allowExcelExport]="true"
            [toolbar]="toolbarOptions" (toolbarClick)='toolbarClick()'>
            <tr>
              <th></th>
              <th>Legajo</th>
              <th>Gremio</th>
              <th>Empleado</th>
              <th width="50">Totales</th>
              <th *ngFor="let meses of mesesDias">{{meses.Nombre}}
                <tr class="diaContainer" id="diaContainer">
                  <th class="dia" id="dia" *ngFor="let dias of meses.Dias" (dblclick)="getMotivoInasistencia(null, null, dias, meses, true)">
                    {{dias}}
                  </th>
                </tr>
              </th>
            </tr>
            <!-- GRILLA RESULTADO -->
            <tr *ngFor="let empleado of result">
              <td>
                <input  type="checkbox"
                        style="vertical-align: middle;"
                        [(ngModel)]="empleado.isSelected"
                        (change)="selectEmpleado(empleado.isSelected, result)">
                <a style="cursor: pointer; margin-right: 5px; vertical-align: middle;"  title="Cambiar fecha de asignación"
                  (click)="editFechas(empleado)"><i class="fa fa-calendar fa-1x" aria-hidden="true"></i>
                </a>
              </td>
              <td>
                <a style="cursor: pointer; margin-right: 5px" (click)="redirectToFichaEmpleado(empleado.EmpleadoId)" title="Ver datos empleado">
                  <i class="fa fa-file fa-1x"></i>
                </a>{{empleado.Legajo}}
              </td>

              <td>{{empleado.GremioNombre | uppercase}}</td>

              <td>{{empleado.EmpleadoApellido | uppercase}}, {{empleado.EmpleadoNombre | uppercase}}</td>
              <td>
                <tr style="display: grid; grid-auto-flow: column;" class="asistBoxContainer">
                  <div class="d-flex">
                    <div class="asistBoxCheck">
                      <div *ngFor="let tipoAsis of tipoAsistenciaList" class="totalHoras asistBox">
                        <div class="horasText" style="height: 100%; margin-top: 6px;">{{getTotalHoras(empleado, tipoAsis)}}</div>
                      </div>
                    </div>
                  </div>
                </tr>
              </td>

              <td *ngFor="let meses of empleado.Intervalo">

                <tr style="display: grid; grid-auto-flow: column;" class="asistBoxContainer">
                  <div *ngFor="let dia of meses.Dias">
                    <div class="asistBoxCheck">
                      <div id="colorBoxes{{empleado.EmpleadoId}}{{tipoAsis.Id}}{{formatDateGris(meses, dia)}}" *ngFor="let tipoAsis of meses.Tipo" class="{{tipoAsis.Nombre}} asistBox"
                        [ngClass]="verAsis(tipoAsis.Id, empleado, dia, meses) != 0? 'asistenciaCheck': ''"
                        (click)="clickHandler(tipoAsis.Id, empleado, dia, meses, false)">
                        <div [ngClass]="verAsis(tipoAsis.Id, empleado, dia, meses) != 0? 'horasText': 'hideText'">
                          {{verAsis(tipoAsis.Id, empleado, dia, meses)}}</div>
                      </div>
                    </div>
                  </div>
                </tr>
              </td>
            </tr>
          </table>
        </div>
        <div fxLayout="row stretch" fxLayout.xs="column" class="hintContainer">
          <!-- <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="primary"
            class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button> -->
          <div style="display: grid;align-items: center; grid-auto-flow: column;">
            <button mat-raised-button (click)="onSave()" [disabled]="isSaving" color="primary"
              class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
            <div *ngFor="let tipoAsis of tipoAsistenciaList" class="{{tipoAsis.Nombre}} asistBox hint">
              <div style="display: flex;width: 20px;">
                <p style="position: relative;
                                    left: 25px;">{{tipoAsis.Nombre}}</p>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
